export default {
  tables: [],
  table: null,
  tableId: null
}
